import type { ButtonVariant } from "@mantine/core";
import type { ReactNode } from "react";

export interface SolveGuidedFlow {
    flowId: string;
    tag: string;
    firstStepId: string;
    steps: Record<string, SolveGuidedFlowStep>;
    tooltip?: ReactNode;
    feedbackOptions: GuideFeedbackOptions;
    reset: VoidFunction;
}

export interface SolveGuidedFlowStep {
    stepId: string;
    tag?: string;
    content: ReactNode;
    progress: number;
    imageUrl?: string;
    variant: GuideStepVariant;
    actions: SolveGuidedFlowAction[];
}

export interface SolveGuidedFlowAction {
    label: string;
    variant?: ButtonVariant;
    nextStepId?: string;
    nextStepAction?: "CloseGuide" | "PreviousStep";
    onClick?: VoidFunction;
    validate?: () => string | undefined;
}

export type GuideStepVariant = "Success" | "Error" | "Default";

export interface GuideFeedbackOptions {
    title: string;
    options: string[];
}

export interface OpenGuideSource {
    source: "auto" | "manual";
    sourceDetails: GuideSourceDetails;
}
export type GuideSourceDetails =
    | "intent"
    | "queue"
    | "tfn"
    | "recommendation"
    | "call-start"
    | "toolbox"
    | "in-progress-guide";
export type CloseGuideSource = "auto" | "closeButton";

export const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
};

/** Rapid7 APIs for device activation may take over 10 seconds to complete */
export const defaultTimeoutInMS = 30_000;
